module.exports = __webpack_public_path__ + "media/images/city/057-atomium-bfdf5ec3fcc22c19bc40925b395e1f6d.svg";